import src from "IMAGE";
export default { src, width: 350, height: 333, blurWidth: 0, blurHeight: 0};
